import { invokeHttp, invokeSse } from './api'

export const list = (list, filter, offset) =>
  invokeHttp('/admin/chat/list', { list, filter, offset })

export const get = (lineId, offset) =>
  invokeHttp('/admin/chat/get', { lineId, offset })

export const getSse = (lineId) =>
  invokeSse(`/admin/chat/get/sse?lineId=${lineId}`)

export const send = (lineId, content, type) =>
  invokeHttp('/admin/chat/send', { lineId, content, type })

export const upload = (image) =>
  invokeHttp('/admin/chat/upload', image)

export const profile = (uid) =>
  `${process.env.VUE_APP_API_URL}/admin/chat/get-line-profile?id=${uid}`

export const setNote = (lineId, status, note) =>
  invokeHttp('/admin/chat/set-note', { lineId, status, note })
